import React from 'react'
import { Card } from 'react-bootstrap'
import { FORMATOS } from '../../common/formato-dashboard'

// Paleta del prototipo: borde izquierdo y color del valor por variante
const VARIANTES = {
    azul: { borde: '#0d6efd', texto: '#0d6efd' },
    neutro: { borde: '#4F517A', texto: '#3b3d66' },
    verde: { borde: '#198754', texto: '#198754' },
    gris: { borde: '#6c757d', texto: '#5c636a' },
    teal: { borde: '#0aa2c0', texto: '#0aa2c0' },
    rojo: { borde: '#dc3545', texto: '#dc3545' }
}

export const SeccionTitulo = ({ children }) => (
    <div
        className='mt-3 mb-2 px-3 py-2 fw-bold text-uppercase'
        style={{ backgroundColor: '#eceef3', borderLeft: '3px solid #4F517A', color: '#4F517A', fontSize: '0.8rem', letterSpacing: '0.04em' }}
    >
        {children}
    </div>
)

export const MetricCard = ({ label, value, format = 'numero', colorVariant = 'neutro', nota, grande = true }) => {
    const { borde, texto } = VARIANTES[colorVariant] || VARIANTES.neutro
    return (
        <Card className='h-100' style={{ borderLeft: `3px solid ${borde}` }}>
            <Card.Body className='py-2'>
                <div className='text-muted text-uppercase' style={{ fontSize: '0.7rem', letterSpacing: '0.05em' }}>{label}</div>
                <div className='fw-bold' style={{ color: texto, fontSize: grande ? '1.6rem' : '1.3rem' }}>
                    {FORMATOS[format](value)}
                </div>
                {nota && <div className='text-muted' style={{ fontSize: '0.7rem' }}>{nota}</div>}
            </Card.Body>
        </Card>
    )
}

export const AlertCard = ({ label, value, nota }) => {
    const sinDato = value === null || value === undefined
    const positivo = Number(value) > 0
    const estilo = sinDato
        ? { backgroundColor: '#e9ecef', color: '#6c757d' }
        : positivo
            ? { backgroundColor: '#fde2e4', color: '#dc3545' }
            : { backgroundColor: '#d1e7dd', color: '#198754' }
    return (
        <Card className='h-100'>
            <Card.Body className='py-2'>
                <div className='small fw-semibold'>{label}</div>
                <div
                    className='d-inline-flex align-items-center justify-content-center rounded-pill fw-bold my-1 px-3'
                    style={{ ...estilo, minWidth: '3rem', height: '2.2rem', fontSize: '1.2rem' }}
                >
                    {FORMATOS.numero(value)}
                </div>
                {nota && <div className='text-muted' style={{ fontSize: '0.7rem' }}>{nota}</div>}
            </Card.Body>
        </Card>
    )
}
